module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


    var clazz = '';
    if(grouped) {
        if(vertical) {
            clazz='btn-group-vertical';
        } else {
            clazz='btn-group';
        }
    }
    var cursor = '';
    if(draggable) {
        cursor = 'cursor:move';
    }
;
__p += '\n\n';
 if(panel) { ;
__p += '\n<div class="card draggable toolbar-panel ui-draggable ui-resizable" id="' +
((__t = (id)) == null ? '' : __t) +
'_panel">\n    <div class="card-header ' +
((__t = (panelCss)) == null ? '' : __t) +
'" style="' +
((__t = (cursor)) == null ? '' : __t) +
'">\n        ';
if(closable) {;
__p += '\n        <button id="' +
((__t = (id)) == null ? '' : __t) +
'_close" type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>\n        ';
};
__p += '\n        <span class="DescartesToolBarTitle">' +
((__t = (title)) == null ? '' : __t) +
'</span>\n    </div>\n    <div class="card-body">\n        <div class="DescartesToolBar ' +
((__t = (clazz)) == null ? '' : __t) +
' flex-wrap" id="' +
((__t = (id)) == null ? '' : __t) +
'" role="group"></div>\n    </div>\n</div>\n';
 } else { ;
__p += '\n<div class="DescartesToolBar ' +
((__t = (clazz)) == null ? '' : __t) +
' flex-wrap" id="' +
((__t = (id)) == null ? '' : __t) +
'" role="group">\n</div>\n';
 } ;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Toolbar/bootstrap4/templates/ToolBar.ejs
// module id = 433
// module chunks = 0